import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Linea_venta from "../components/Linea_venta.vue";
import Presupuesto from "../components/Presupuesto.vue";
import PresupuestoLineaCom from "../components/PresupuestoLineaCom.vue";
import SeguimientoLineaCom from "../components/SeguimientoLineaCom.vue";
import PresupuestoLineaNominas from "../components/PresupuestoLineaNominas.vue";
import Forma_farmaceutica from "../components/Forma_farmaceutica.vue";
import Centro_costo from "../components/Centro_costo.vue";
import Cuenta_contable from "../components/Cuenta_contable.vue";
import Articulo from "../components/Articulo.vue";
import Equipo from "../components/Equipo.vue";
import Area from "../components/Area.vue";
import Subarea from "../components/Subarea.vue";
import Area_presupuesto from "../components/Area_presupuesto.vue";
import Cambios_personal from "../components/Cambios_personal.vue";
import Cargo from "../components/Cargo.vue";
import Nit from "../components/Nit.vue";
import Persona from "../components/Persona.vue";
import Gasto from "../components/Gasto.vue";
import Servicio from "../components/Servicio.vue";
import Subcategoria from "../components/Subcategoria.vue";
import SubcategoriaConfig from "../components/SubcategoriaConfig.vue";
import Tipo_aprobacion from "../components/Tipo_aprobacion.vue";
import Grupo_nomina from "../components/Grupo_nomina.vue";
import Parametro from "../components/Parametro.vue";
import Categoria from "../components/Categoria.vue";
import Planillas from "../components/Planillas.vue";
import Usuario from "../components/Usuario.vue";
import Uniforme from "../components/Uniforme.vue";
import SolicitudNuevoPersonal from "../components/SolicitudNuevoPersonal.vue";
import Login from "../components/Login.vue";
import AuthCallback from "../views/AuthCallback.vue";
import VacacionesAnuales from "../views/VacacionesAnuales.vue";
import Pruebas from "../components/Pruebas.vue";
import Reporte_vacacion from "../components/Reporte_vacacion.vue";
import Indicadores from "../components/Indicadores.vue";
import Familia from "../components/Familia.vue";
import Gdp from "../components/Gdp.vue";
import Analisis_importe from "../components/Analisis_importe.vue";
import Analisis_cantidad from "../components/Analisis_cantidad.vue";
import Analisis_cantidad_AP from "../components/Analisis_cantidad_AP.vue";
import Analisis_total_ganado from "../components/Analisis_total_ganado.vue";
import Analisis_gastos from "../components/Analisis_gastos.vue";
import store from "../store/index.js";

import decode from 'jwt-decode'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      administrador: true,
      gerente: true,
      producto: true,
      encargado: true,
      prestaciones: true,
      nominas: true,
      comunicaciones: true,
      jefe: true,
      reportes: true,
    },
  },
  {
    path: "/Linea_venta",
    name: "Linea_venta",
    component: Linea_venta,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Forma_farmaceutica",
    name: "Forma_farmaceutica",
    component: Forma_farmaceutica,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Centro_costo",
    name: "Centro_costo",
    component: Centro_costo,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Cuenta_contable",
    name: "Cuenta_contable",
    component: Cuenta_contable,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Articulo",
    name: "Articulo",
    component: Articulo,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Equipo",
    name: "Equipo",
    component: Equipo,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Gdp",
    name: "Gdp",
    component: Gdp,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Presupuesto",
    name: "Presupuesto",
    component: Presupuesto,
    meta: {
      administrador: true,
      encargado: true,
      gerente: false,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/PresupuestoLineaCom",
    name: "PresupuestoLineaCom",
    component: PresupuestoLineaCom,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: false,
      comunicaciones: true,
      producto: true,
      jefe: false,
    },
  },
  {
    path: "/SeguimientoLineaCom",
    name: "SeguimientoLineaCom",
    component: SeguimientoLineaCom,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: false,
      comunicaciones: true,
      producto: true,
      jefe: false,
    },
  },
  {
    path: "/PresupuestoLineaNominas",
    name: "PresupuestoLineaNominas",
    component: PresupuestoLineaNominas,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: true,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Area",
    name: "Area",
    component: Area,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Gasto",
    name: "Gasto",
    component: Gasto,
    meta: {
      administrador: true,
      gerente: true,
      encargado: true,
      prestaciones: false,
      nominas: true,
      comunicaciones: true,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Subarea",
    name: "Subarea",
    component: Subarea,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Area_presupuesto",
    name: "Area_presupuesto",
    component: Area_presupuesto,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Cargo",
    name: "Cargo",
    component: Cargo,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Nit",
    name: "Nit",
    component: Nit,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Persona",
    name: "Persona",
    component: Persona,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Reporte_vacacion",
    name: "Reporte_vacacion",
    component: Reporte_vacacion,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
      reportes: true,
    },
  },
  {
    path: "/VacacionesAnuales",
    name: "VacacionesAnuales",
    component: VacacionesAnuales,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
      reportes: true,
    },
  },
  {
    path: "/Servicio",
    name: "Servicio",
    component: Servicio,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Subcategoria",
    name: "Subcategoria",
    component: Subcategoria,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: true,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/SubcategoriaConfig",
    name: "SubcategoriaConfig",
    component: SubcategoriaConfig,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: true,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Categoria",
    name: "Categoria",
    component: Categoria,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: true,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Planillas",
    name: "Planillas",
    component: Planillas,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: true,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Tipo_aprobacion",
    name: "Tipo_aprobacion",
    component: Tipo_aprobacion,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: false,
      comunicaciones: true,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Grupo_nomina",
    name: "Grupo_nomina",
    component: Grupo_nomina,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: true,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Parametro",
    name: "Parametro",
    component: Parametro,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Usuario",
    name: "Usuario",
    component: Usuario,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Login",
    name: "Login",
    component: Login,
    meta: {
      libre: true,
    },
  },
  {
    path: "/Pruebas",
    name: "Pruebas",
    component: Pruebas,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Indicadores",
    name: "Indicadores",
    component: Indicadores,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Uniforme",
    name: "Uniforme",
    component: Uniforme,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: true,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Famlia",
    name: "Familia",
    component: Familia,
    meta: {
      administrador: true,
      gerente: false,
      encargado: true,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: false,
      title: "Nested - About Page - Example App",
    },
  },
  {
    path: "/SolicitudNuevoPersonal",
    name: "SolicitudNuevoPersonal",
    component: SolicitudNuevoPersonal,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: false,
      comunicaciones: false,
      producto: false,
      jefe: true,
    },
  },

  {
    path: "/Analisis_importe",
    name: "Analisis_importe",
    component: Analisis_importe,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },

  {
    path: "/Analisis_cantidad",
    name: "Analisis_cantidad",
    component: Analisis_cantidad,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Analisis_cantidad_AP",
    name: "Analisis_cantidad_AP",
    component: Analisis_cantidad_AP,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Analisis_total_ganado",
    name: "Analisis_total_ganado",
    component: Analisis_total_ganado,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Analisis_gastos",
    name: "Analisis_gastos",
    component: Analisis_gastos,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },
  {
    path: "/Cambios_personal",
    name: "Cambios_personal",
    component: Cambios_personal,
    meta: {
      administrador: true,
      gerente: false,
      encargado: false,
      prestaciones: false,
      nominas: true,
      comunicaciones: false,
      producto: false,
      jefe: false,
    },
  },

  {
    path: "/auth/callback",
    name: "AuthCallback",
    component: AuthCallback,
    meta: {
      libre: true
    },
  },

  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
//router.afterEach((to) => {
//  gtag('config', 'G-C0DS104EEC', {
//  page_path: to.fullPath,
//    app_name: 'FrancoPrueba',
//    send_page_view: true,
//  });
//});
router.beforeEach((to, from, next) => {
  // Verificar si la ruta es libre (no requiere autenticación)
  if (to.matched.some(record => record.meta.libre)){
    next()
    return
  }
  
  // Si ya estamos en login, evitar bucles
  if (to.name === 'Login') {
    next()
    return
  }
  
  // Verificar si el usuario está autenticado
  if (!store.state.usuario || !store.state.token) {
    // Intentar autologin antes de redirigir
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = decode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.user === "")
        {localStorage.removeItem("token");
          next({ name: 'Login' });
          return;
        }
          
        if (decodedToken.exp > currentTime) {
          // Token válido, actualizar store
          store.commit("setToken", token);
          store.commit("setUsuario", decodedToken);
          
          // Ahora verificar permisos con el usuario actualizado (pasamos el objeto completo)
          checkPermissions(to, next, decodedToken);
          return;
        } else {
          // Token expirado
          localStorage.removeItem("token");
          next({ name: 'Login' });
          return;
        }
      } catch (error) {
        // Token inválido
        localStorage.removeItem("token");
        next({ name: 'Login' });
        return;
      }
    } else {
      next({ name: 'Login' });
      return;
    }
  }
  
  // Usuario autenticado, verificar permisos por rol
  checkPermissions(to, next, store.state.usuario);
})

function checkPermissions(to, next, usuario) {
  // Si no hay usuario, redirigir a login
  if (!usuario) {
    next({ name: 'Login' });
    return;
  }

  // Función helper para verificar si el usuario tiene alguno de los roles especificados
  const hasAnyRole = (roleNames) => {
    if (!usuario.roles || !Array.isArray(usuario.roles)) {
      // Los roles pueden venir como string JSON del token
      let rolesArray = [];
      if (typeof usuario.roles === 'string') {
        try {
          rolesArray = JSON.parse(usuario.roles);
        } catch (e) {
          console.error('Error parsing roles from JWT:', e);
          rolesArray = [];
        }
      } else if (usuario.rol) {
        // Compatibilidad con sistema de rol único
        return roleNames.includes(usuario.rol);
      }
      
      if (Array.isArray(rolesArray)) {
        return rolesArray.some(role => 
          roleNames.includes(role.codigo) || roleNames.includes(role.descripcion)
        );
      }
      
      return false;
    }
    
    return usuario.roles.some(role => 
      role.activo && (roleNames.includes(role.nombre) || roleNames.includes(role.codigo))
    );
  };

  // Mapeo de permisos de ruta a roles
  const routePermissions = {
    administrador: ['ADM', 'Administrador', 'Super Administrador', 'ADMINISTRADOR DEL SISTEMA'],
    gerente: ['GER', 'Gerente', 'ADM', 'Administrador', 'Super Administrador', 'GERENTE GENERAL', 'ADMINISTRADOR DEL SISTEMA'],
    encargado: ['ENC', 'Encargado', 'ADM', 'Administrador', 'Super Administrador'],
    prestaciones: ['PRE', 'Prestaciones', 'ADM', 'Administrador', 'Super Administrador'],
    nominas: ['NOM', 'Nominas', 'ADM', 'Administrador', 'Super Administrador'],
    comunicaciones: ['COM', 'Comunicaciones', 'ADM', 'Administrador', 'Super Administrador'],
    jefe: ['JEF', 'Jefe', 'ADM', 'Administrador', 'Super Administrador'],
    producto: ['GDP', 'Producto', 'ADM', 'Administrador', 'Super Administrador'],
    reportes: ['REP', 'Reportes', 'ADM', 'Administrador', 'Super Administrador']
  };

  // Verificar permisos para cada tipo de ruta
  let hasPermission = false;

  // Verificar cada permiso requerido por la ruta
  Object.keys(routePermissions).forEach(permission => {
    if (to.matched.some(record => record.meta[permission])) {
      if (hasAnyRole(routePermissions[permission])) {
        hasPermission = true;
      }
    }
  });

  // Si la ruta no tiene meta específicos, permitir acceso (rutas públicas autenticadas)
  if (!to.matched.some(record => 
    record.meta.administrador || record.meta.gerente || record.meta.encargado || 
    record.meta.prestaciones || record.meta.nominas || record.meta.comunicaciones || 
    record.meta.jefe || record.meta.producto || record.meta.reportes
  )) {
    hasPermission = true;
  }

  if (hasPermission) {
    next();
  } else {
    // Evitar bucle infinito - solo redirigir si no estamos ya en Home
    if (to.name !== 'Home') {
      next({ name: 'Home' });
    } else {
      next();
    }
  }
}

export default router;
